var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('h1',{staticClass:"error-code"},[_vm._v("404")]),_c('p',{staticClass:"error-info"},[_vm._v(" Page not found ")])])
}]

export { render, staticRenderFns }